import React, { useState } from "react";
import { NavCustomizerProps } from "../../../Types/Layout.type";
import { Nav, NavLink } from "reactstrap";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import { navCustomizerData } from "../../../Data/Layout/ThemeCustomizer";
import { FiSettings } from "react-icons/fi";

export default function NavCustomizer({
  callbackNav,
  selected,
}: NavCustomizerProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Settings Icon (Bottom-Right) */}
      <div
        style={{
          position: "fixed",
          bottom: "-260px",
          right: "20px",
          zIndex: 1050,
        }}
      >
        <button
          onClick={() => setIsOpen(!isOpen)}
          style={{
            background: "#0d6efd",
            borderRadius: "50%",
            border: "none",
            width: "30px", // smaller size
            height: "30px", // smaller size
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
            cursor: "pointer",
            color: "#fff",
          }}
        >
          <FiSettings size={18} /> {/* smaller icon */}
        </button>
      </div>

      {/* Show Nav only when isOpen = true */}
      {isOpen && (
        <Nav className="flex-column nac-pills" vertical>
          <NavLink
            className={selected === "sidebar-type" ? "active" : ""}
            onClick={() => callbackNav("sidebar-type", true)}
          >
            <div className="settings">
              <Image
                className="img-fluid"
                src={dynamicImage(`customizer/brush.png`)}
                alt=""
              />
            </div>
            <span>{"Quick option"}</span>
          </NavLink>
          {navCustomizerData.map((item) => (
            <NavLink
              key={item.id}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div>
                <Image
                  className="img-fluid"
                  src={dynamicImage(`customizer/${item.image}`)}
                  alt=""
                />
              </div>
              <span>{item.title}</span>
            </NavLink>
          ))}
        </Nav>
      )}
    </>
  );
}
